import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";
import Swal from "sweetalert2";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    startPrimePaper,
    submitPrimePaper
} from "../config/userApi";

import "./FreeMCQExam.css";


function PrimePaperStart() {

    const navigate = useNavigate();

    const {
        paperId
    } = useParams();


    /* ---------------------------------------------------------------
       DEFAULT EXAM DURATION
    --------------------------------------------------------------- */

    const DEFAULT_EXAM_DURATION = 20 * 60;


    /* ---------------------------------------------------------------
       STATES
    --------------------------------------------------------------- */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);

    const [
        navigatorOpen,
        setNavigatorOpen
    ] = useState(false);

    const [
        loading,
        setLoading
    ] = useState(true);

    const [
        error,
        setError
    ] = useState("");

    const [
        name,
        setName
    ] = useState("Student");

    const [
        paper,
        setPaper
    ] = useState(null);

    const [
        questions,
        setQuestions
    ] = useState([]);

    const [
        answers,
        setAnswers
    ] = useState({});

    const [
        currentQuestion,
        setCurrentQuestion
    ] = useState(0);

    const [
        remainingTime,
        setRemainingTime
    ] = useState(
        DEFAULT_EXAM_DURATION
    );

    const [
        examStartTime,
        setExamStartTime
    ] = useState("");

    const [
        taggedQuestions,
        setTaggedQuestions
    ] = useState([]);

    const [
        submitting,
        setSubmitting
    ] = useState(false);


    /* ---------------------------------------------------------------
       LOAD USER + PREMIUM PAPER
    --------------------------------------------------------------- */

    useEffect(() => {

        let mounted = true;


        const loadExam = async () => {

            try {

                setLoading(true);
                setError("");


                /* ---------------------------------------------------
                   CHECK PAPER ID
                --------------------------------------------------- */

                if (!paperId) {

                    setError(
                        "Paper ID is missing."
                    );

                    return;

                }


                /* ---------------------------------------------------
                   CHECK USER LOGIN
                --------------------------------------------------- */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                if (
                    meResponse.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );

                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );

                    return;

                }


                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (
                    !meResponse.ok
                ) {

                    throw new Error(
                        meResult.message ||
                        "Unable to verify user."
                    );

                }


                /* ---------------------------------------------------
                   USER NAME
                --------------------------------------------------- */

                if (
                    meResult.user
                ) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";


                    if (mounted) {

                        setName(
                            username
                        );

                    }

                }


                /* ---------------------------------------------------
                   START PREMIUM PAPER
                --------------------------------------------------- */

                const response =
                    await startPrimePaper(
                        paperId
                    );


                console.log(
                    "PREMIUM PAPER START STATUS:",
                    response.status
                );


                /* ---------------------------------------------------
                   UNAUTHORIZED
                --------------------------------------------------- */

                if (
                    response.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );

                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );

                    return;

                }


                const result =
                    await response.json();


                console.log(
                    "PREMIUM PAPER START RESPONSE:",
                    result
                );


                /* ---------------------------------------------------
                   FORBIDDEN
                --------------------------------------------------- */

                if (
                    response.status === 403
                ) {

                    await Swal.fire({

                        icon:
                            "info",

                        title:
                            "Unable to Start Paper",

                        text:
                            result.message ||
                            "You cannot start this paper.",

                        confirmButtonText:
                            "OK"

                    });


                    navigate(
                        -1
                    );

                    return;

                }


                /* ---------------------------------------------------
                   OTHER API ERROR
                --------------------------------------------------- */

                if (
                    !response.ok
                ) {

                    throw new Error(
                        result.message ||
                        "Unable to load premium paper."
                    );

                }


                /* ---------------------------------------------------
                   API STATUS
                --------------------------------------------------- */

                if (
                    !result.status
                ) {

                    throw new Error(
                        result.message ||
                        "Unable to load premium paper."
                    );

                }


                /* ---------------------------------------------------
                   PAPER
                --------------------------------------------------- */

                const paperData =
                    result.paper ||
                    result.data?.paper ||
                    null;


                if (mounted) {

                    setPaper(
                        paperData
                    );

                }


                /* ---------------------------------------------------
                   QUESTIONS
                --------------------------------------------------- */

                const apiQuestions =
                    Array.isArray(
                        result.questions
                    )
                        ? result.questions
                        : Array.isArray(
                            result.data?.questions
                        )
                            ? result.data.questions
                            : [];


                const formattedQuestions =
                    apiQuestions.map(
                        (
                            item,
                            index
                        ) => ({

                            id:
                                item.question_id ||
                                item.study_id ||
                                item.id,

                            question_id:
                                item.question_id ||
                                item.study_id ||
                                item.id,

                            question:
                                item.question ||
                                "",

                            option1:
                                item.option1 ||
                                "",

                            option2:
                                item.option2 ||
                                "",

                            option3:
                                item.option3 ||
                                "",

                            option4:
                                item.option4 ||
                                "",

                            explanation:
                                item.explanation ||
                                "",

                            sort_order:
                                item.sort_order ||
                                index + 1

                        })
                    );


                if (mounted) {

                    setQuestions(
                        formattedQuestions
                    );

                }


                /* ---------------------------------------------------
                   DURATION
                --------------------------------------------------- */

                const duration =
                    Number(
                        paperData?.duration ||
                        result.duration ||
                        20
                    );


                const apiTime =
                    Number(
                        result.time_left ||
                        result.data?.time_left ||
                        duration * 60
                    );


                if (mounted) {

                    setRemainingTime(
                        apiTime
                    );

                }


                /* ---------------------------------------------------
                   EXAM START TIME
                --------------------------------------------------- */

                if (mounted) {

                    setExamStartTime(
                        result.exam_start_time ||
                        result.data?.exam_start_time ||
                        new Date().toISOString()
                    );

                }


                console.log(
                    "CURRENT ATTEMPT:",
                    result.attempt_number ||
                    result.attempt_count ||
                    1
                );


            } catch (error) {

                console.error(
                    "PREMIUM PAPER START ERROR:",
                    error
                );


                if (mounted) {

                    setError(
                        error.message ||
                        "Unable to load premium paper."
                    );

                }

            } finally {

                if (mounted) {

                    setLoading(false);

                }

            }

        };


        loadExam();


        return () => {

            mounted = false;

        };


    }, [
        paperId,
        navigate
    ]);


    /* ---------------------------------------------------------------
       COUNTDOWN TIMER
    --------------------------------------------------------------- */

    useEffect(() => {

        if (
            loading ||
            questions.length === 0 ||
            submitting
        ) {

            return;

        }


        if (
            remainingTime <= 0
        ) {

            handleSubmit(
                true
            );

            return;

        }


        const timer =
            setInterval(
                () => {

                    setRemainingTime(
                        previous => {

                            if (
                                previous <= 1
                            ) {

                                return 0;

                            }


                            return previous - 1;

                        }
                    );

                },
                1000
            );


        return () => {

            clearInterval(
                timer
            );

        };


    }, [
        remainingTime,
        loading,
        questions.length,
        submitting
    ]);


    /* ---------------------------------------------------------------
       TIMER FORMAT
    --------------------------------------------------------------- */

    const minutes =
        Math.floor(
            remainingTime / 60
        );


    const seconds =
        remainingTime % 60;


    const formattedTime =
        `${String(minutes).padStart(
            2,
            "0"
        )}:${String(seconds).padStart(
            2,
            "0"
        )}`;


    /* ---------------------------------------------------------------
       CURRENT QUESTION
    --------------------------------------------------------------- */

    const question =
        questions[
            currentQuestion
        ];


    /* ---------------------------------------------------------------
       COUNTS
    --------------------------------------------------------------- */

    const attemptedCount =
        Object.keys(
            answers
        ).length;


    const taggedCount =
        taggedQuestions.length;


    const unattemptedCount =
        Math.max(
            questions.length -
            attemptedCount,
            0
        );


    /* ---------------------------------------------------------------
       SELECT ANSWER
    --------------------------------------------------------------- */

    const handleAnswer = (
        answer
    ) => {

        if (!question) {

            return;

        }


        setAnswers(
            previous => ({

                ...previous,

                [question.id]:
                    answer

            })
        );

    };


    /* ---------------------------------------------------------------
       NEXT
    --------------------------------------------------------------- */

    const handleNext = () => {

        if (
            currentQuestion <
            questions.length - 1
        ) {

            setCurrentQuestion(
                previous =>
                    previous + 1
            );

        }

    };


    /* ---------------------------------------------------------------
       PREVIOUS
    --------------------------------------------------------------- */

    const handlePrevious = () => {

        if (
            currentQuestion > 0
        ) {

            setCurrentQuestion(
                previous =>
                    previous - 1
            );

        }

    };


    /* ---------------------------------------------------------------
       GO TO QUESTION
    --------------------------------------------------------------- */

    const goToQuestion = (
        index
    ) => {

        if (
            index >= 0 &&
            index < questions.length
        ) {

            setCurrentQuestion(
                index
            );

            setNavigatorOpen(
                false
            );

        }

    };


    /* ---------------------------------------------------------------
       TAG QUESTION
    --------------------------------------------------------------- */

    const toggleTag = () => {

        if (!question) {

            return;

        }


        setTaggedQuestions(
            previous => {

                if (
                    previous.includes(
                        question.id
                    )
                ) {

                    return previous.filter(
                        id =>
                            id !==
                            question.id
                    );

                }


                return [
                    ...previous,
                    question.id
                ];

            }
        );

    };


    /* ---------------------------------------------------------------
       SUBMIT EXAM
    --------------------------------------------------------------- */

    const handleSubmit = async (
        automatic = false
    ) => {

        if (
            submitting
        ) {

            return;

        }


        /* -----------------------------------------------------------
           CONFIRM SUBMIT
        ----------------------------------------------------------- */

        if (
            !automatic
        ) {

            const confirmSubmit =
                await Swal.fire({

                    title:
                        "Submit Premium Paper?",

                    html:
                        `
                        <div style="text-align:left;">

                            <p style="margin-bottom:15px;">
                                Are you sure you want to submit this premium paper?
                            </p>

                            <div style="
                                display:grid;
                                grid-template-columns:repeat(3, 1fr);
                                gap:10px;
                                margin-top:15px;
                            ">

                                <div style="
                                    padding:10px;
                                    background:#f0fdf4;
                                    border-radius:8px;
                                    text-align:center;
                                ">

                                    <strong style="
                                        display:block;
                                        font-size:20px;
                                    ">
                                        ${attemptedCount}
                                    </strong>

                                    <small>
                                        Attempted
                                    </small>

                                </div>


                                <div style="
                                    padding:10px;
                                    background:#fff7ed;
                                    border-radius:8px;
                                    text-align:center;
                                ">

                                    <strong style="
                                        display:block;
                                        font-size:20px;
                                    ">
                                        ${unattemptedCount}
                                    </strong>

                                    <small>
                                        Unattempted
                                    </small>

                                </div>


                                <div style="
                                    padding:10px;
                                    background:#eff6ff;
                                    border-radius:8px;
                                    text-align:center;
                                ">

                                    <strong style="
                                        display:block;
                                        font-size:20px;
                                    ">
                                        ${taggedCount}
                                    </strong>

                                    <small>
                                        Tagged
                                    </small>

                                </div>

                            </div>


                            <p style="
                                margin-top:15px;
                                margin-bottom:0;
                                font-size:13px;
                                color:#6b7280;
                            ">

                                Correct answer:
                                +${paper?.marks || 1}

                                <br />

                                Wrong answer:
                                -${paper?.negative_marks || "0.33"}

                            </p>

                        </div>
                        `,

                    icon:
                        "question",

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Submit Paper",

                    cancelButtonText:
                        "Continue",

                    reverseButtons:
                        true,

                    allowOutsideClick:
                        false,

                    allowEscapeKey:
                        true

                });


            if (
                !confirmSubmit.isConfirmed
            ) {

                return;

            }

        }


        /* -----------------------------------------------------------
           AUTOMATIC SUBMIT
        ----------------------------------------------------------- */

        if (
            automatic
        ) {

            await Swal.fire({

                icon:
                    "warning",

                title:
                    "Time Over",

                text:
                    "Your exam time is over. Your paper will be submitted automatically.",

                confirmButtonText:
                    "Submit"

            });

        }


        try {

            setSubmitting(
                true
            );


            setNavigatorOpen(
                false
            );


            /* -------------------------------------------------------
               PREPARE ANSWERS
            ------------------------------------------------------- */

            const answerList =
                questions.map(
                    questionItem => ({

                        question_id:
                            questionItem.question_id,

                        answer:
                            answers[
                                questionItem.question_id
                            ] ||
                            null

                    })
                );


            console.log(
                "PREMIUM PAPER SUBMISSION ANSWERS:",
                answerList
            );


            /* -------------------------------------------------------
               SUBMIT API
            ------------------------------------------------------- */

            const response =
                await submitPrimePaper(

                    paperId,

                    answerList,

                    examStartTime

                );


            console.log(
                "PREMIUM PAPER SUBMIT STATUS:",
                response.status
            );


            /* -------------------------------------------------------
               UNAUTHORIZED
            ------------------------------------------------------- */

            if (
                response.status === 401
            ) {

                Cookies.remove(
                    "username"
                );


                navigate(
                    "/login",
                    {
                        replace: true
                    }
                );


                return;

            }


            /* -------------------------------------------------------
               READ JSON
            ------------------------------------------------------- */

            const result =
                await response.json();


            console.log(
                "PREMIUM PAPER SUBMIT RESPONSE:",
                result
            );


            /* -------------------------------------------------------
               API ERROR
            ------------------------------------------------------- */

            if (
                !response.ok
            ) {

                throw new Error(
                    result.message ||
                    "Unable to submit paper."
                );

            }


            /* -------------------------------------------------------
               STATUS ERROR
            ------------------------------------------------------- */

            if (
                !result.status
            ) {

                throw new Error(
                    result.message ||
                    "Unable to submit paper."
                );

            }


            /* -------------------------------------------------------
               RESULT DATA
            ------------------------------------------------------- */

            const resultData =
                result?.data ||
                null;


            if (
                !resultData
            ) {

                throw new Error(
                    "Result data was not received from server."
                );

            }


            console.log(
                "PREMIUM PAPER RESULT DATA:",
                resultData
            );


            /* -------------------------------------------------------
               SUCCESS ALERT
            ------------------------------------------------------- */

            await Swal.fire({

                icon:
                    "success",

                title:
                    "Paper Submitted",

                html:
                    `
                    <div>

                        <p>
                            Your premium paper has been submitted successfully.
                        </p>

                        <strong>
                            Score:
                            ${resultData?.score ?? 0}
                        </strong>

                    </div>
                    `,

                confirmButtonText:
                    "View Result"

            });


            /* -------------------------------------------------------
               NAVIGATE TO PREMIUM PAPER RESULT
               ------------------------------------------------------- */

            const historyId =
                resultData?.history_id ||
                resultData?.id;


            if (
                !historyId
            ) {

                throw new Error(
                    "History ID was not received from server."
                );

            }


            navigate(

                `/premium-paper/result/${encodeURIComponent(
                    historyId
                )}`,

                {

                    replace:
                        true,

                    state: {

                        result:
                            resultData,

                        paper:
                            resultData?.paper ||
                            paper

                    }

                }

            );


        } catch (error) {

            console.error(
                "PREMIUM PAPER SUBMIT ERROR:",
                error
            );


            Swal.fire({

                icon:
                    "error",

                title:
                    "Submission Failed",

                text:
                    error.message ||
                    "Unable to submit paper.",

                confirmButtonText:
                    "OK"

            });

        } finally {

            setSubmitting(
                false
            );

        }

    };


    /* ---------------------------------------------------------------
       LOADING
    --------------------------------------------------------------- */

    if (
        loading
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={
                            name
                        }
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="free-exam-page">

                        <div className="result-card">

                            <div className="result-icon">

                                <i className="bi bi-hourglass-split"></i>

                            </div>


                            <h1>
                                Loading Premium Paper...
                            </h1>


                            <p className="result-subtitle">

                                Please wait while the questions are loading.

                            </p>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /* ---------------------------------------------------------------
       ERROR
    --------------------------------------------------------------- */

    if (
        error
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={
                            name
                        }
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="free-exam-page">

                        <div className="result-card">

                            <div className="result-icon">

                                <i className="bi bi-exclamation-circle-fill"></i>

                            </div>


                            <h1>
                                Unable to Load Premium Paper
                            </h1>


                            <p className="result-subtitle">

                                {
                                    error
                                }

                            </p>


                            <div className="result-actions">

                                <button
                                    type="button"
                                    className="exam-btn secondary-btn"
                                    onClick={() =>
                                        navigate(
                                            -1
                                        )
                                    }
                                >

                                    <i className="bi bi-arrow-left me-2"></i>

                                    Back to Papers

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /* ---------------------------------------------------------------
       NO QUESTIONS
    --------------------------------------------------------------- */

    if (
        !questions.length
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={
                            name
                        }
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="free-exam-page">

                        <div className="result-card">

                            <div className="result-icon">

                                <i className="bi bi-journal-x"></i>

                            </div>


                            <h1>
                                No Questions Found
                            </h1>


                            <p className="result-subtitle">

                                This premium paper does not contain any questions.

                            </p>


                            <div className="result-actions">

                                <button
                                    type="button"
                                    className="exam-btn secondary-btn"
                                    onClick={() =>
                                        navigate(
                                            -1
                                        )
                                    }
                                >

                                    <i className="bi bi-arrow-left me-2"></i>

                                    Back to Papers

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /* ---------------------------------------------------------------
       MAIN EXAM
    --------------------------------------------------------------- */

    return (

        <div className="user-dashboard">


            {/* SIDEBAR */}

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            <main className="dashboard-main">


                {/* HEADER */}

                <UserHeader
                    name={
                        name
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <div className="free-exam-page">


                    {/* =================================================
                        TOP HEADER
                    ================================================= */}

                    <div className="exam-top-card">

                        <div>

                            <div className="exam-badge">

                                <i className="bi bi-file-earmark-text me-2"></i>

                                PREMIUM PAPER

                            </div>


                            <h1>

                                {
                                    paper?.paper ||
                                    "Premium Paper"
                                }

                            </h1>


                            <p>

                                Category:{" "}

                                {
                                    paper?.category ||
                                    paper?.subject ||
                                    "Premium"
                                }

                            </p>

                        </div>


                        <div className="exam-progress-wrapper">

                            <div className="exam-progress-box">

                                <span>
                                    Question
                                </span>


                                <strong>

                                    {
                                        currentQuestion + 1
                                    }

                                    <small>

                                        {" / "}

                                        {
                                            questions.length
                                        }

                                    </small>

                                </strong>

                            </div>


                            <div className="exam-progress-box exam-timer-box">

                                <span>
                                    Remaining Time
                                </span>


                                <strong>
                                    {
                                        formattedTime
                                    }
                                </strong>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        MARKING INFO
                    ================================================= */}

                    <div
                        style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                            padding: "12px 18px",
                            borderRadius: "10px",
                            background: "#fff7ed",
                            border: "1px solid #fed7aa",
                            color: "#9a3412",
                            fontSize: "14px"
                        }}
                    >

                        <i className="bi bi-file-earmark-check me-2"></i>

                        <strong>
                            Paper Marking:
                        </strong>

                        {" "}

                        +{paper?.marks || 1}
                        {" "}for Correct Answer

                        {" • "}

                        -{paper?.negative_marks || "0.33"}
                        {" "}for Wrong Answer

                    </div>


                    {/* =================================================
                        STATS
                    ================================================= */}

                    <div className="exam-stats">


                        <div className="exam-stat attempted">

                            <div className="stat-icon">

                                <i className="bi bi-check-lg"></i>

                            </div>


                            <div>

                                <span>
                                    Attempted
                                </span>


                                <strong>
                                    {
                                        attemptedCount
                                    }
                                </strong>

                            </div>

                        </div>


                        <div className="exam-stat unattempted">

                            <div className="stat-icon">

                                <i className="bi bi-circle"></i>

                            </div>


                            <div>

                                <span>
                                    Unattempted
                                </span>


                                <strong>
                                    {
                                        unattemptedCount
                                    }
                                </strong>

                            </div>

                        </div>


                        <div className="exam-stat tagged">

                            <div className="stat-icon">

                                <i className="bi bi-bookmark-fill"></i>

                            </div>


                            <div>

                                <span>
                                    Tagged
                                </span>


                                <strong>
                                    {
                                        taggedCount
                                    }
                                </strong>

                            </div>

                        </div>


                        <div className="exam-stat total">

                            <div className="stat-icon">

                                <i className="bi bi-list-ol"></i>

                            </div>


                            <div>

                                <span>
                                    Total
                                </span>


                                <strong>
                                    {
                                        questions.length
                                    }
                                </strong>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        EXAM GRID
                    ================================================= */}

                    <div className="exam-grid">


                        {/* =================================================
                            QUESTION CARD
                        ================================================= */}

                        <section className="question-card">


                            {/* QUESTION HEADER */}

                            <div className="question-header">

                                <div className="question-number">

                                    Q.
                                    {
                                        currentQuestion + 1
                                    }

                                </div>


                                <button
                                    type="button"
                                    className={
                                        taggedQuestions.includes(
                                            question.id
                                        )
                                            ? "tag-btn active"
                                            : "tag-btn"
                                    }
                                    onClick={
                                        toggleTag
                                    }
                                >

                                    <i
                                        className={
                                            taggedQuestions.includes(
                                                question.id
                                            )
                                                ? "bi bi-bookmark-fill"
                                                : "bi bi-bookmark"
                                        }
                                    ></i>


                                    <span>

                                        {
                                            taggedQuestions.includes(
                                                question.id
                                            )
                                                ? "Tagged"
                                                : "Tag Question"
                                        }

                                    </span>

                                </button>

                            </div>


                            {/* QUESTION */}

                            <div className="question-text">

                                <h2
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            question.question ||
                                            ""
                                    }}
                                ></h2>

                            </div>


                            {/* OPTIONS */}

                            <div className="options-list">

                                {[
                                    {
                                        key: "A",
                                        value: "1",
                                        text: question.option1
                                    },
                                    {
                                        key: "B",
                                        value: "2",
                                        text: question.option2
                                    },
                                    {
                                        key: "C",
                                        value: "3",
                                        text: question.option3
                                    },
                                    {
                                        key: "D",
                                        value: "4",
                                        text: question.option4
                                    }
                                ].map(
                                    option => {

                                        const selected =
                                            answers[
                                                question.id
                                            ] ===
                                            option.value;


                                        return (

                                            <button
                                                type="button"
                                                key={
                                                    option.key
                                                }
                                                className={
                                                    selected
                                                        ? "option-item selected"
                                                        : "option-item"
                                                }
                                                onClick={() =>
                                                    handleAnswer(
                                                        option.value
                                                    )
                                                }
                                            >

                                                <span className="option-letter">

                                                    {
                                                        option.key
                                                    }

                                                </span>


                                                <span
                                                    className="option-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            option.text ||
                                                            ""
                                                    }}
                                                ></span>


                                                <span className="option-check">

                                                    {
                                                        selected && (

                                                            <i className="bi bi-check-circle-fill"></i>

                                                        )
                                                    }

                                                </span>

                                            </button>

                                        );

                                    }
                                )}

                            </div>


                            {/* NAVIGATION */}

                            <div className="question-navigation">


                                {/* PREVIOUS */}

                                <button
                                    type="button"
                                    className="exam-btn secondary-btn"
                                    onClick={
                                        handlePrevious
                                    }
                                    disabled={
                                        currentQuestion === 0
                                    }
                                >

                                    <i className="bi bi-arrow-left me-2"></i>

                                    Previous

                                </button>


                                {/* NEXT / SUBMIT */}

                                {
                                    currentQuestion ===
                                    questions.length - 1

                                        ? (

                                            <button
                                                type="button"
                                                className="exam-btn submit-btn"
                                                onClick={() =>
                                                    handleSubmit(
                                                        false
                                                    )
                                                }
                                                disabled={
                                                    submitting
                                                }
                                            >

                                                {
                                                    submitting
                                                        ? "Submitting..."
                                                        : "Submit Paper"
                                                }

                                                <i className="bi bi-check2-circle ms-2"></i>

                                            </button>

                                        )

                                        : (

                                            <button
                                                type="button"
                                                className="exam-btn primary-btn"
                                                onClick={
                                                    handleNext
                                                }
                                            >

                                                Next

                                                <i className="bi bi-arrow-right ms-2"></i>

                                            </button>

                                        )
                                }

                            </div>

                        </section>


                        {/* =================================================
                            MOBILE NAVIGATOR
                        ================================================= */}

                        <button
                            type="button"
                            className="mobile-navigator-btn"
                            onClick={() =>
                                setNavigatorOpen(
                                    true
                                )
                            }
                            aria-label="Open Question Navigator"
                        >

                            <i className="bi bi-grid-3x3-gap-fill"></i>

                            <span>
                                Questions
                            </span>

                        </button>


                        {/* MOBILE OVERLAY */}

                        {
                            navigatorOpen && (

                                <div
                                    className="navigator-overlay"
                                    onClick={() =>
                                        setNavigatorOpen(
                                            false
                                        )
                                    }
                                ></div>

                            )
                        }


                        {/* =================================================
                            QUESTION PALETTE
                        ================================================= */}

                        <aside
                            className={
                                navigatorOpen
                                    ? "question-palette mobile-open"
                                    : "question-palette"
                            }
                        >


                            {/* HEADER */}

                            <div className="palette-header">

                                <div>

                                    <h3>
                                        Question Navigator
                                    </h3>

                                    <p>
                                        Jump to any question
                                    </p>

                                </div>


                                <div className="palette-header-actions">

                                    <i className="bi bi-grid-3x3-gap-fill"></i>


                                    <button
                                        type="button"
                                        className="mobile-navigator-close"
                                        onClick={() =>
                                            setNavigatorOpen(
                                                false
                                            )
                                        }
                                        aria-label="Close Question Navigator"
                                    >

                                        <i className="bi bi-x-lg"></i>

                                    </button>

                                </div>

                            </div>


                            {/* LEGEND */}

                            <div className="palette-legend">

                                <div>

                                    <span className="legend-dot current"></span>

                                    Current

                                </div>


                                <div>

                                    <span className="legend-dot attempted"></span>

                                    Attempted

                                </div>


                                <div>

                                    <span className="legend-dot tagged"></span>

                                    Tagged

                                </div>


                                <div>

                                    <span className="legend-dot unattempted"></span>

                                    Not Attempted

                                </div>

                            </div>


                            {/* QUESTION NUMBERS */}

                            <div className="question-numbers">

                                {
                                    questions.map(
                                        (
                                            item,
                                            index
                                        ) => {

                                            const isCurrent =
                                                currentQuestion ===
                                                index;


                                            const isAttempted =
                                                Boolean(
                                                    answers[
                                                        item.id
                                                    ]
                                                );


                                            const isTagged =
                                                taggedQuestions.includes(
                                                    item.id
                                                );


                                            let className =
                                                "question-number-btn";


                                            if (
                                                isCurrent
                                            ) {

                                                className +=
                                                    " current";

                                            } else if (
                                                isTagged
                                            ) {

                                                className +=
                                                    " tagged";

                                            } else if (
                                                isAttempted
                                            ) {

                                                className +=
                                                    " attempted";

                                            }


                                            return (

                                                <button
                                                    type="button"
                                                    key={
                                                        item.id
                                                    }
                                                    className={
                                                        className
                                                    }
                                                    onClick={() =>
                                                        goToQuestion(
                                                            index
                                                        )
                                                    }
                                                    title={
                                                        `Question ${
                                                            index + 1
                                                        }`
                                                    }
                                                >

                                                    {
                                                        index + 1
                                                    }


                                                    {
                                                        isTagged && (

                                                            <span className="mini-tag">

                                                                <i className="bi bi-bookmark-fill"></i>

                                                            </span>

                                                        )
                                                    }

                                                </button>

                                            );

                                        }
                                    )
                                }

                            </div>


                            {/* SUMMARY */}

                            <div className="palette-summary">

                                <div>

                                    <span>
                                        Attempted
                                    </span>

                                    <strong>
                                        {
                                            attemptedCount
                                        }
                                    </strong>

                                </div>


                                <div>

                                    <span>
                                        Remaining
                                    </span>

                                    <strong>
                                        {
                                            unattemptedCount
                                        }
                                    </strong>

                                </div>

                            </div>


                            {/* SUBMIT */}

                            <button
                                type="button"
                                className="palette-submit-btn"
                                onClick={() =>
                                    handleSubmit(
                                        false
                                    )
                                }
                                disabled={
                                    submitting
                                }
                            >

                                <i className="bi bi-send-check-fill me-2"></i>


                                {
                                    submitting
                                        ? "Submitting..."
                                        : "Submit Paper"
                                }

                            </button>

                        </aside>

                    </div>

                </div>

            </main>

        </div>

    );

}


export default PrimePaperStart;

